import {Component, EventEmitter, Input, OnInit, Output, SimpleChange} from "@angular/core";
import {ClassificationOperatorType} from "../../../../../../models/classification-operator";
import {SelectOperatorType} from "../../../../../../models/select-operator";
import {BaseFieldDeterminantComponent} from "./base-field-determinant.component";

@Component({
  selector: "select-determinant",
  templateUrl: "./select-determinant.component.html",
  styles: [],
})
export class SelectDeterminantComponent extends BaseFieldDeterminantComponent {

  public operators: string[];
  @Input() public isTargetComponent: boolean;
  @Input() public selectValue: string;
  @Input() public selections: any[];
  @Input() public operator: SelectOperatorType;
  @Output() public selectValueResponse = new EventEmitter();
  @Output() public operatorResponse = new EventEmitter();
  @Input() public fieldType: string;
  @Input() public fields: any [] = [];
  @Input() public sourceFormFieldKey: string;

  public ngOnInit() {
    if (this.fieldType && (this.fieldType.toUpperCase() === "SELECTBOXES" || this.fieldType.toUpperCase() === "RADIO") ) {
      this.operators = Object.keys(ClassificationOperatorType);
    } else {
      this.operators = Object.keys(SelectOperatorType);
    }
    this.fields = this.fields.filter((f) => {
      return f.type === "selectboxes" || f.type === "radio" || f.type === "text" || f.type === "textfield";
    });
    super.ngOnInit();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.fields && changes.fields.currentValue) {
      // this.fields = this.fields.filter((field) => (field.type === "select"));
    }
    super.ngOnChanges(changes);
  }

  public selectValueChanged(newValue: any) {
    this.selectValueResponse.emit({selectValue: newValue});
  }

  public operatorValueChanged() {
    this.operatorResponse.emit(this.operator);
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.selectValueResponse.emit({sourceFormFieldKey: this.sourceFormFieldKey});
  }
}
